import {
  REQUEST_SOURCE_STATS,
  REQUEST_SOURCE_STATS_ERROR,
  RECEIVE_SOURCE_STATS
} from 'actions'
import { getSourceStatsKey } from 'selectors'
import createApiMiddlewareReducer from './utils/create-api-middleware-reducer'

const reducer = createApiMiddlewareReducer({
  request: REQUEST_SOURCE_STATS,
  failure: REQUEST_SOURCE_STATS_ERROR,
  receive: RECEIVE_SOURCE_STATS
})

export default function (state = {}, { type, payload = {} }) {
  switch (type) {
    case REQUEST_SOURCE_STATS:
    case REQUEST_SOURCE_STATS_ERROR:
    case RECEIVE_SOURCE_STATS:
      const { workspaceSlug, date } = payload
      const key = getSourceStatsKey(workspaceSlug, date)
      return {
        ...state,
        [key]: reducer(state[key], { type, payload })
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/source-stats.js